import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  getBankAccountHolderName({ bank, number }) {
    return defaultClient.get(`/bank-accounts/find-holder-name?${qs.stringify({ bank, number })}`)
  },
  getBankCodes() {
    return defaultClient.get('/bank-accounts/bank-choices')
  },
  /**
   *
   * @param {*} param0
   * @returns
   */
  postBankAccounts({ bank, number }) {
    return defaultClient.post('/bank-accounts', { bank, number })
  },
}
